import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Wrapper = styled(Link)`
    text-decoration-thickness: 0.05em;
    &:link {
        color: ${({ theme }) => theme.link};
    }
    &:visited {
        color: ${({ theme }) => theme.link};
    }
    &:hover {
        color: ${({ theme }) => theme.highlight};
    }
    &:active {
        color: ${({ theme }) => theme.active};
    }
`

const BlankLink = styled(Link)`
    all: unset;
    display: flex;
    flex-direction: column;
    width: fit-content;
`


export const buildAccountURL = (toAccount, customerId, loyaltyAccountId) => {
    if (toAccount) {
        const { isWashClub, customerId, accountId, loyaltyAccountId } = toAccount;
        return (isWashClub || customerId) ? '/user/' + customerId : '/loyaltyUser/' + (accountId || loyaltyAccountId)
    }
    if (customerId) {
        return '/user/' + customerId;
    }
    if (loyaltyAccountId) {
        return '/loyaltyUser/' + loyaltyAccountId
    }
    return false;
}

const LinkTo = ({ inherit, toAccount, customerId, loyaltyAccountId, ...props }) => {
    const accountURL = buildAccountURL(toAccount, customerId, loyaltyAccountId);
    if (accountURL) {
        props.to = accountURL;
    }
    return inherit ? <BlankLink {...props}>{props.label || props.children}</BlankLink> : <Wrapper {...props}>{props.label || props.children}</Wrapper>;
}

export default LinkTo;
